import { buildSeriesRebasePlan, type EditScope } from './seriesRebase';

export type InstallmentRebaseMode = EditScope;

export type InstallmentRebaseEntry = {
    installmentNumber: number;
    date: string;
    invoiceMonth?: string;
};

type BuildInstallmentRebasePlanParams = {
    installmentNumbers: number[];
    anchorInstallmentNumber: number;
    mode: InstallmentRebaseMode;
    baseDate: string;
    baseInvoiceMonth?: string;
};

/** Adapter: a posição da série é o número da parcela (1-based, lista arbitrária — ordenada no motor). */
export function buildInstallmentRebasePlan({
    installmentNumbers,
    anchorInstallmentNumber,
    mode,
    baseDate,
    baseInvoiceMonth,
}: BuildInstallmentRebasePlanParams): InstallmentRebaseEntry[] {
    return buildSeriesRebasePlan({
        positions: installmentNumbers,
        anchor: anchorInstallmentNumber,
        mode,
        baseDate,
        baseInvoiceMonth,
    }).map((entry) => ({
        installmentNumber: entry.position,
        date: entry.date,
        invoiceMonth: entry.invoiceMonth,
    }));
}

export function stripInstallmentSuffix(description: string): string {
    return description.replace(/\s*\(\d+\/\d+\)$/, '').trim();
}
